"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));

var _reactstrap = require("reactstrap");

var _utils = require("@dom/utils");

var EmailSubscriptionModal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(EmailSubscriptionModal, _Component);

  function EmailSubscriptionModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, EmailSubscriptionModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(EmailSubscriptionModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      email: '',
      emailErrorMessage: null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function (e) {
      e.preventDefault();

      var error = _this.validateEmail();

      return error ? _this.handleEmailErrorMessage(error) : _this.postData();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "validateEmail", function () {
      var email = _this.state.email;
      if (!email) return 'Oops, you forgot your email';
      if (!(0, _isEmail["default"])(email)) return 'Is that a valid email.?';
      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "postData",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _utils.api.postWithoutToken(_utils.endpoints.profile.newslettersSubscriptions, {
                email: _this.state.email,
                context: _this.props.context
              });

            case 3:
              _this.props.toggle();

              _this.props.onSuccess();

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              _this.handleEmailErrorMessage('Oops, there seems to be a problem. Please try again later.');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleEmailErrorMessage", function (error) {
      return _this.setState({
        emailErrorMessage: error
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleEmailChange", function (e) {
      return _this.setState({
        email: e.target.value
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(EmailSubscriptionModal, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          email = _this$state.email,
          emailErrorMessage = _this$state.emailErrorMessage;
      var _this$props = this.props,
          on = _this$props.on,
          toggle = _this$props.toggle,
          aboveEmail = _this$props.aboveEmail,
          belowEmail = _this$props.belowEmail;
      return _react["default"].createElement(_reactstrap.Modal, {
        isOpen: on,
        toggle: toggle,
        className: "full-width-modal"
      }, _react["default"].createElement(_reactstrap.ModalBody, null, _react["default"].createElement("div", {
        className: "modal-box"
      }, aboveEmail, _react["default"].createElement("div", {
        className: "email-box"
      }, _react["default"].createElement(_reactstrap.Form, {
        id: "betaMessageForm",
        inline: true
      }, _react["default"].createElement(_reactstrap.Input, {
        type: "email",
        name: "email",
        id: "email",
        value: email,
        placeholder: "something@domain.com",
        className: "input-error",
        autofocus: true,
        onChange: this.handleEmailChange
      }), _react["default"].createElement(_reactstrap.Button, {
        color: "let-know",
        onClick: this.handleSubmit,
        id: "betaMessageLemmeKnow"
      }, "Get It!"), _react["default"].createElement("div", {
        className: "error"
      }, emailErrorMessage && emailErrorMessage))), belowEmail, _react["default"].createElement(_reactstrap.Button, {
        color: "invisible",
        onClick: toggle
      }, "No Thanks"), ' ')));
    }
  }]);
  return EmailSubscriptionModal;
}(_react.Component); // const mapDispatchToProps = dispatch => ({
//   onEmailSubscription: () => dispatch(onEmailSubscription()),
// });
// const connected = connect(
//   null,
//   mapDispatchToProps
// )(EmailSubscriptionModal);
// export default connected;


exports["default"] = EmailSubscriptionModal;
(0, _defineProperty2["default"])(EmailSubscriptionModal, "defaultProps", {
  onSuccess: function onSuccess() {},
  context: ''
});